import { createEvent } from '@cobuildlab/react-simple-state';
import { FileUploadInfoType } from '../../shared/types';

export const OnFileUploadInfo = createEvent<FileUploadInfoType>();
export const OnFileUploadInfoError = createEvent();
